module.exports = __webpack_public_path__ + "img/16.52c21cd4.jpg";